type CalculateRefinanceSavingsArgs = {
  amount: number;
  duration: number;
};

/**
 * @description Copied from legacy
 * @todo improve
 */
export function calculateRefinanceSavings({
  amount,
  duration,
}: CalculateRefinanceSavingsArgs) {
  let interest = 0.06;
  const monthlyInterest = interest / 12;
  // Fees.
  const startUpFee = 950;
  const monthlyFee = 30;
  const creditCardInterest = 0.22;
  const monthlyCreditCardInterest = creditCardInterest / 12;
  const minPay = 250;
  const cardPay = 0.03;
  const cardFee = 30;

  // Calculates monthly cost with loan.
  const monthlyCost =
    ((amount + startUpFee) * monthlyInterest) /
      (1 - Math.pow(1 + monthlyInterest, -12 * duration)) +
    monthlyFee;

  interest = Math.round(amount * monthlyCreditCardInterest);
  let saldo = Math.round(amount + interest);
  let payment = Math.round(
    Math.min(Math.max(minPay, saldo * cardPay), saldo) + cardFee
  );
  let minSaldo = Math.round(saldo - payment + cardFee);

  let i = 1;
  let paymentAverage = payment;

  while (saldo > 0) {
    interest = Math.round(minSaldo * monthlyCreditCardInterest);
    saldo = Math.round(minSaldo + interest);
    payment = Math.round(
      Math.min(Math.max(minPay, saldo * cardPay), saldo) + cardFee
    );
    minSaldo = Math.round(saldo - payment + cardFee);
    // add += interest;
    if (i < 12) {
      paymentAverage += payment;
    }
    i++;
  }

  paymentAverage /= 12;

  const monthlySaving = paymentAverage - monthlyCost;

  if (monthlySaving > 0) {
    return parseInt(monthlySaving.toFixed(0));
  }

  return 0;
}
